import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { AnimateModule } from '../animate/animate.module';
import { select, Store } from '@ngxs/store';
import {
  AccountState,
  AccountStateAddEventPlace,
  AccountStateRemoveEvent,
  AccountStateRemoveEventPlace,
} from 'shared/src/pages/core/pages/account/account.state';
import { UserType, WwwAppState, WwwRouteSlug } from 'shared/src/models';
import { NgxMaskPipe } from 'ngx-mask';
import { IAccountOrder } from 'shared/src/pages/core/pages/account/models/account-order';
import { RouterModule } from '@angular/router';
import { GtmClickDirective } from 'shared/src/directives';

@Component({
  selector: 'app-header-cart',
  templateUrl: './header-cart.component.html',
  styleUrls: ['./header-cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, AnimateModule, NgxMaskPipe, RouterModule, GtmClickDirective],
})
export class HeaderCartComponent {
  // public readonly orders = select(AccountState.events);
  public readonly summPrice = select(AccountState.summPrice);
  public readonly user = select(WwwAppState.user);

  public readonly accountOrders = input<IAccountOrder[]>([]);

  public readonly UserType = UserType;
  public readonly wwwRouteSlug = WwwRouteSlug;

  private readonly _store = inject(Store);

  public removePlace(event: IAccountOrder): void {
    this._store.dispatch([new AccountStateRemoveEventPlace({ event })]);
  }

  public addPlace(event: IAccountOrder): void {
    this._store.dispatch([new AccountStateAddEventPlace({ event })]);
  }

  public removeEvent(event: IAccountOrder): void {
    this._store.dispatch([new AccountStateRemoveEvent({ event })]);
  }
}
